const PhoneNumber = () => import('@/uikit/PhoneNumber/PhoneNumber.vue');
export default PhoneNumber;
